const mEditionMapChartItemRightSubMenu = {
  mEditionMapChartItemRightSubMenu: {
    items: {
      messages: 'Mensajes',
      node: 'Contenido',
      points: 'Puntajes'
    }
  }
}

export default mEditionMapChartItemRightSubMenu
